import styled from 'styled-components/macro'
import { link, spacing, Typography, themeColor, BaseColor, rem } from '@unbounded/unbounded-components'

export const Mailto = styled.a`
  ${link};
  ${Typography.titleSmall};
  ${Typography.textRegular};
  margin-bottom: ${spacing(1.5)};
`

export const CantFindAnswer = styled.span`
  ${Typography.textRegular};
  display: flex;
  border-top: 1px solid ${themeColor(BaseColor.shade_40)};
  color: ${themeColor(BaseColor.shade_50)};
  margin-top: ${spacing(2)};
  padding-top: ${spacing(2)};
`

export const MailtoSmall = styled(Mailto)`
  ${Typography.bodySmall};
  margin-bottom: 0;
`

export const Quote = styled.div`
  background: ${themeColor(BaseColor.shade_20)};
  padding: ${spacing(0.5)};
  margin: ${spacing()} 0;
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: ${spacing(0.5)};
  max-width: ${rem(400)};

  strong {
    ${Typography.textStrong};
  }

  a {
    ${link};
  }
`
